"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Tooltip = require("./Tooltip.styles");
var _OffsetBox = require("../../Layout/OffsetBox");
var _useOffsetBox2 = require("../../Layout/OffsetBox/useOffsetBox");
var _Card = require("../Card");
var _dom = require("../../utilities/dom");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Tooltip = function Tooltip(props) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var anchor = props.anchor,
    children = props.children,
    isOpenOnFocus = props.isOpenOnFocus,
    isInteractive = props.isInteractive,
    _props$position = props.position,
    position = _props$position === void 0 ? 'bottom' : _props$position,
    _props$anchorWidth = props.anchorWidth,
    anchorWidth = _props$anchorWidth === void 0 ? 'fit-content' : _props$anchorWidth,
    header = props.header;
  var _useOffsetBox = (0, _useOffsetBox2.useOffsetBox)(isOpenOnFocus),
    anchorRef = _useOffsetBox.anchorRef,
    dropContentRef = _useOffsetBox.dropContentRef,
    handleAnchorFocus = _useOffsetBox.handleAnchorFocus,
    handleOffsetBoxBlur = _useOffsetBox.handleOffsetBoxBlur,
    handleOffsetBoxLeave = _useOffsetBox.handleOffsetBoxLeave,
    isOpen = _useOffsetBox.isOpen,
    close = _useOffsetBox.close,
    open = _useOffsetBox.open;
  var _useState = (0, _react.useState)(position),
    _useState2 = _slicedToArray(_useState, 2),
    actualBoxPosition = _useState2[0],
    setActualBoxPosition = _useState2[1];
  var styles = (0, _Tooltip.useStyles)(actualBoxPosition, props);
  var handleBoxPositionChange = function handleBoxPositionChange(pos) {
    setActualBoxPosition(pos);
  };
  var handleAnchorBlur = function handleAnchorBlur() {
    if (isInteractive && dropContentRef.current) {
      var tabAble = (0, _dom.getKeyboardFocusableElements)(dropContentRef.current);
      if (tabAble.length > 0) {
        tabAble[0].focus();
        handleOffsetBoxBlur();
        return;
      }
    }
    close();
  };
  var handleAnchorClick = function handleAnchorClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (isMobileView) {
      open();
    }
  };
  (0, _react.useEffect)(function () {
    if (position) {
      setActualBoxPosition(position);
    }
  }, [position]);
  var anchorTabIndex = isOpenOnFocus && anchorRef !== null && anchorRef !== void 0 && anchorRef.current && (0, _dom.getKeyboardFocusableElements)(anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current).length === 0 ? 0 : -1;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Tooltip'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBox.OffsetBox, {
      position: position,
      offset: 0,
      isOpen: isOpen,
      isCenteredToAnchor: true,
      onBoxPositionChange: handleBoxPositionChange,
      anchorWidth: anchorWidth,
      anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        ref: anchorRef,
        onClick: handleAnchorClick,
        onMouseEnter: isMobileView ? undefined : open,
        onMouseLeave: isMobileView ? undefined : isInteractive ? handleOffsetBoxLeave : close,
        tabIndex: anchorTabIndex,
        onFocus: handleAnchorFocus,
        onBlur: handleAnchorBlur,
        children: anchor
      }),
      children: children && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Tooltip__content'],
        ref: dropContentRef,
        onMouseEnter: isInteractive ? open : undefined,
        onMouseLeave: isInteractive ? handleOffsetBoxLeave : undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
          children: [header && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-Tooltip__header'],
            children: header
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.Card.Section, {
            size: "small",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-Tooltip__inner-content'],
              children: children
            })
          })]
        })
      })
    })
  });
};
exports.Tooltip = Tooltip;